<div class="dark-blue">
  <nestas-toolbar [steps]="steps"></nestas-toolbar>
</div>

<!-- This should never display, just for extra security -->
<div *ngIf="!isAdmin()">
  <div mat-card-image>
    <img src="/assets/error.png" width="100" height="100" class="cardImage">
  </div>
  <mat-card-title>{{translate.instant('MESSAGE.UNAUTHORIZED')}}</mat-card-title>
</div>

<div class="wrap admin-component" *ngIf="isAdmin()">

  <div [hidden]="tabGroup.selectedIndex >= 2">
    <button mat-fab class="add-button" (click)="addClick(tabGroup)">
      <i class="material-icons">add</i>
    </button>
  </div>

  <nestas-searchbar *ngIf="tabindex != 5" (search)="filterUser(tabGroup, $event)" class="flexbox wrap-search">
  </nestas-searchbar>

  <mat-tab-group #tabGroup class="mat-tab-group" [(selectedIndex)]="tabindex">
    <!-- JOBS -->
    <mat-tab>
      <ng-template mat-tab-label>{{translate.instant('DATA.JOBS')}}</ng-template>
      <table class="default-table">
        <tr>
          <th>Nederlands</th>
          <th>Français</th>
          <th>English</th>
          <th>{{translate.instant('DATA.MANDATORY')}}</th>
          <th></th>
        </tr>
        <tr *ngFor="let j of jobs.display">
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="j.name.nl" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="j.name.fr" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="j.name.en" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-checkbox [(ngModel)]="j.mandatory" type="checkbox" class="align-middle"></mat-checkbox>
          </td>
          <td><i class="material-icons cursor" (click)="removeJob(j)">delete</i></td>
        </tr>
      </table>
      <mat-card-actions align="end" class="clear-margin save-button">
        <button mat-raised-button color="primary" (click)="saveJobs()">
          {{translate.instant('BUTTON.ACTION.SAVE')}}
        </button>
      </mat-card-actions>
    </mat-tab>

    <!-- FILE TYPES -->
    <mat-tab>
      <ng-template mat-tab-label>{{translate.instant('DATA.FILETYPES')}}</ng-template>
      <table class="default-table">
        <tr>
          <th>Nederlands</th>
          <th>Français</th>
          <th>English</th>
          <th></th>
        </tr>
        <tr *ngFor="let ft of fileTypes.display">
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="ft.name.nl" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="ft.name.fr" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="ft.name.en" type="text">
            </mat-form-field>
          </td>
          <td><i class="material-icons cursor" (click)="removeFileType(ft)">delete</i></td>
        </tr>
      </table>
      <mat-card-actions align="end" class="clear-margin save-button">
        <button mat-raised-button color="primary" (click)="saveFileTypes()">
          {{translate.instant('BUTTON.ACTION.SAVE')}}
        </button>
      </mat-card-actions>
    </mat-tab>

    <!-- DIU MODELS -->
    <mat-tab>
      <ng-template mat-tab-label>{{translate.instant('ADMIN.NG-TEMPLATES')}}</ng-template>
      <table class="default-table">
        <tr>
          <th></th>
          <th>Villa</th>
          <th>Row House</th>
          <th>Flat</th>
        </tr>
        <tr *ngIf="templates">
          <td>{{translate.instant('ADMIN.TEMPLATE_NEWHOUSE')}}</td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.newHouse.villa.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.newHouse.villa.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.newHouse.villa.en" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.newHouse.rowHouse.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.newHouse.rowHouse.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.newHouse.rowHouse.en" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.newHouse.flat.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.newHouse.flat.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.newHouse.flat.en" type="text">
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{translate.instant('ADMIN.TEMPLATE_EXISTINGHOUSE')}}</td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.existingHouse.villa.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.existingHouse.villa.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.existingHouse.villa.en" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.existingHouse.rowHouse.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.existingHouse.rowHouse.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.existingHouse.rowHouse.en" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.existingHouse.flat.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.existingHouse.flat.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.existingHouse.flat.en" type="text">
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{translate.instant('ADMIN.TEMPLATE_BETERRENOVATE')}}</td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.betterRenovate.villa.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.betterRenovate.villa.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.betterRenovate.villa.en" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.betterRenovate.rowHouse.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.betterRenovate.rowHouse.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.betterRenovate.rowHouse.en" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput placeholder="Nederlands" [(ngModel)]="templates.betterRenovate.flat.nl" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Francais" [(ngModel)]="templates.betterRenovate.flat.fr" type="text">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="English" [(ngModel)]="templates.betterRenovate.flat.en" type="text">
            </mat-form-field>
          </td>
        </tr>
      </table>
      <mat-card-actions align="end" class="clear-margin save-button">
        <button mat-raised-button color="primary" (click)="saveTemplates()">
          {{translate.instant('BUTTON.ACTION.SAVE')}}
        </button>
      </mat-card-actions>
    </mat-tab>

    <!-- USERS -->
    <mat-tab>
      <ng-template mat-tab-label>{{translate.instant('DATA.USERS')}}</ng-template>
      <table class="default-table">
        <tr>
          <th>{{translate.instant('DATA.NAME')}}</th>
          <th>{{translate.instant('DATA.PAID_LICENSE')}}</th>
          <th>{{translate.instant('DATA.TYPE')}}<br />
            <select (change)="userFilterChange($event)">
              <option [value]="-1">&nbsp;</option>
              <option *ngFor="let t of types" [value]="t">{{t}}</option>
            </select>
          </th>
          <!--<th>{{translate.instant('DATA.USER_SINCE')}}</th>-->
          <th>{{translate.instant('DATA.CONTACT')}}</th>
          <th>{{translate.instant('DATA.PID_LIMIT')}}</th>
          <th>{{translate.instant('DATA.NUM_PIDS')}}</th>
          <th>{{translate.instant('DATA.PIDINFO')}}
            <select (change)="pidFilterChange($event)">
              <option [value]="-1">&nbsp;</option>
              <option *ngFor="let t of pidTypes" [value]="t">{{t}}</option>
            </select>
          </th>
        </tr>

        <tr *ngFor="let u of users.display">

          <td class="highlight">
            <div style="margin-bottom:20px;">
              {{u.firstname}} {{u.lastname}}
              <div style="color:#ccc; font-size:smaller">{{u._id}}</div>
              <div *ngIf="u.userSince || u.createdAt" matTooltip="{{u.userSince | amCalendar}}">{{(u.userSince ||
                u.createdAt) | amTimeAgo:true }}</div>
                <div style="color:#ccc; font-size:smaller">Expiry: {{u.trialExpires | date: 'dd/MM/yyyy'}}</div>
            </div>

            <button *ngIf="!setp[u._id]" mat-raised-button (click)="editUser(u)" color="primary">
              {{translate.instant('BUTTON.ACTION.UPDATE')}}
            </button>
          </td>
          <td>
            <div style="margin-bottom:50px;">

              <mat-checkbox [(ngModel)]="u.paidLicense" [checked]="u.paidLicense" id="paid_license_{{u._id}}">
              </mat-checkbox>
            </div>
            <button *ngIf="!setp[u._id]" mat-raised-button (click)="impersonateUser(u)" color="primary"
              class="btn-impersonate">
              {{translate.instant('BUTTON.ACTION.IMPERSONATE')}}
            </button>
          </td>

          <td>
            <div style="margin-bottom:47px;">
              <select [(ngModel)]="u.role" *ngIf="canChangeRole(u)">
                <option *ngFor="let t of types" [value]="t">{{t}}</option>
              </select>
              <span *ngIf="!canChangeRole(u)">{{u.role}}</span>
            </div>

            <button mat-raised-button *ngIf="!setp[u._id]" (click)="startPasswordUser(u)">
              {{translate.instant('BUTTON.ACTION.SET_PASSWORD')}}
            </button>
            <button *ngIf="setp[u._id]" mat-raised-button (click)="setPasswordUser(u)" color="primary">
              {{translate.instant('BUTTON.ACTION.SET_PASSWORD')}}
            </button>
            <mat-form-field *ngIf="setp[u._id]" [ngStyle]="{'width': '80px'}">
              <input matInput [(ngModel)]="u.password" type="password">
            </mat-form-field>
          </td>

          <td>
            <ul class="no-style" style="width: 300px;">
              <li><span *ngIf="u.address">{{u.address.address}}</span></li>
              <li><span *ngIf="u.address">{{u.address.zip}} {{u.address.city}}</span></li>
              <li>{{u.phone}}</li>
              <li><a class="cursor contact-info-data link" (click)="sendMessageTo(u.email)">{{u.email}}</a></li>
              {{translate.instant('DATA.COMPANY')}}:
              <mat-form-field [ngStyle]="{'width': '160px'}">
                <input matInput [(ngModel)]="u.company">
              </mat-form-field>
            </ul>
          </td>
          <td>
            <mat-form-field [ngStyle]="{'width': '80px'}">
              <input matInput [(ngModel)]="u.PIDLimit" type="number">
            </mat-form-field>
          </td>
          <td>
            <span [ngClass]="{'orange': u.PIDLimit == u.nbPID, 'red': u.PIDLimit < u.nbPID}">{{u.nbPID}}</span>
          </td>
          <td>
            <div class="small" *ngIf="u.nbPID != u.nbPIDp">{{u.nbPIDp}} persoonlijk</div>
            <div class="small" *ngIf="u.nbShared">{{u.nbShared}}x gedeeld</div>
            <div class="small" *ngIf="u.nbSharedR">{{u.nbSharedR}}x gedeeld ontvangen</div>
            <div class="small" *ngIf="u.nbTransferred">{{u.nbTransferred}}x overgedragen</div>
            <div class="small" *ngIf="u.nbTransferredR">{{u.nbTransferredR}}x ontvangen</div>
            <div class="small" *ngIf="u.nbExpired">{{u.nbExpired}}x vervallen</div>
            <div class="small" >{{u.nbUnit}}x unit</div>

          </td>

        </tr>


      </table>
    </mat-tab>


    <!-- PIDS -->
    <mat-tab>
      <ng-template mat-tab-label>{{translate.instant('DATA.PIDS')}}</ng-template>
      <table class="default-table">
        <tr>
          <th>{{translate.instant('DATA.NAME')}}</th>
          <th>{{translate.instant('DATA.OWNER')}}</th>
          <th>{{translate.instant('DATA.CONTACT')}}</th>
          <th>{{translate.instant('DATA.PIDINFO')}}
            <select (change)="pidExpiredFilterChange($event)">
              <option [value]="-1">&nbsp;</option>
              <option *ngFor="let t of expiredTypes" [value]="t">{{t}}</option>
            </select>
          </th>
        </tr>

        <tr *ngFor="let u of pids.display">

          <td class="highlight">
            <div style="margin-bottom:20px;">
              {{u.name}}
              <div style="color:#ccc; font-size:smaller">{{u._id}}</div>
            </div>
          </td>

         

          <td>
            <div style="margin-bottom:47px;">
              <div *ngIf="u.PIDOwner">
                {{u.PIDOwner.name}}<br />
                {{u.PIDOwner.email}}<br />
                {{u.PIDOwner.company}}
              </div>
            </div>
          </td>

          <td>
            <ul class="no-style">
              <li><span *ngIf="u.address">{{u.address.address}}</span></li>
              <li><span *ngIf="u.address">{{u.address.zip}} {{u.address.city}}</span></li>
              <li>{{u.phone}}</li>
              <li><a class="cursor contact-info-data link" (click)="sendMessageTo(u.email)">{{u.email}}</a></li>
            </ul>
          </td>

          <td>
            <div style="width: 400px;">
              <div><label>Expired: </label><mat-checkbox [(ngModel)]="u.expired" [checked]="u.expired" id="expired_{{u._id}}">
              </mat-checkbox></div>
              <div><label>Created: </label><input [(ngModel)]="u.createdAt" type="date"> &nbsp; <a (click)="now(u)">now</a></div>
              <div><label>Expires: </label><input [(ngModel)]="u.expires" type="date"> &nbsp; <a (click)="addOneYear(u)">+1Y</a></div>
              
              <button *ngIf="!setp[u._id]" mat-raised-button (click)="editPid(u)" color="primary">
                {{translate.instant('BUTTON.ACTION.UPDATE')}}
              </button>
            </div>
          </td>
        </tr>


      </table>
    </mat-tab>


    <!-- DB -->
    <mat-tab>

      <ng-template mat-tab-label>DB</ng-template>
      <table class="default-table tight">
        <tr>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="pidToMod" placeholder="id van de PID" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="newOwner" placeholder="id van de owner" type="text">
            </mat-form-field>
          </td>
          <td>
            <button mat-raised-button (click)="modOwnerPID()">
              Gebruiker aanpassen. Oppassen!
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="oldPIDOwner" placeholder="id van de oude Gebruiker" type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="newPIDOwner" placeholder="id van de niewe Gebruiker" type="text">
            </mat-form-field>
          </td>
          <td>
            <button mat-raised-button (click)="switchOwnerPIDs()">
              Gebruikers wisselen. Oppassen!
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="pidToDelete" placeholder="id van de PID" type="text">
            </mat-form-field>
          </td>
          <td></td>
          <td>
            <button mat-raised-button (click)="removePID()">
              PID Verwijderen. Oppassen!
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="profileToDelete" placeholder="id van het Profiel" type="text">
            </mat-form-field>
          </td>
          <td></td>
          <td>
            <button mat-raised-button (click)="removeProfile()">
              Profiel Verwijderen. Oppassen!
            </button>
          </td>
        </tr>
      </table>

      <h1>Debug info</h1>
      <pre>domain: {{env.domain}}</pre>
      <pre>production: {{env.production}}</pre>

      <h1>Node Debug info</h1>
      <pre>{{sysinfo}}</pre>
    </mat-tab>
  </mat-tab-group>
</div>

<modal *ngIf="modal && modal.sendMessage" [show]="modal.sendMessage" [closable]=true
  (closed)="modal.sendMessage = false;">
  <div class="modal-title-content">{{translate.instant('CONTACT.TITLE')}}</div>
  <div class="modal-body-content">
    <message-admin #modalMessageAdmin [toEmail]="toEmail" (done)="modal.sendMessage = false;"></message-admin>
  </div>
  <div class="modal-footer-content">
    <button mat-raised-button color="primary" (click)="modalMessageAdmin.sendMail();">
      {{translate.instant('CONTACT.SEND')}}
    </button>
  </div>
</modal>